export enum ContentTableTypeEnum {
  Playlists = "playlists",
  Videos = "videos",
  Images = "images",
  Audio = "audio",
}
